import { v4 as uuidv4 } from 'uuid';
import { CATEGORY, CATEGORY_NAME, COMPONENT_TYPE, EVENT_TYPE, TYPE } from '@/const';
import router from 'next/router';
import Api from '@/services/apis';
import * as gtag from '@/lib/gtag';

export const makeTwoDimensionalArray = (origin: any[], size: number) =>
  Array.from({ length: Math.ceil(origin.length / size) }, (_, i) =>
    origin.slice(i * size, i * size + size),
  );

export const objectToQueryString = (obj: any) => {
  const keyValuePairs = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      keyValuePairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
  }
  return keyValuePairs.join('&');
};

interface IRouterOption {
  adCategoryCd: string;
  destinationType: string;
  promotionSeq: string;
  itSeq: string;
  gpMappSeq: string;
  adsSeq: string;
  trackCdType: string;
  payYn: string;
  adsDtlSeq: string;
  page?: string;
  refEventId?: string;
}

export const getUrl = (params: IRouterOption): string => {
  const {
    adCategoryCd,
    destinationType,
    promotionSeq,
    itSeq,
    gpMappSeq,
    adsSeq,
    trackCdType,
    payYn,
    adsDtlSeq,
    refEventId,
  } = params;
  const media = router.query.media as string;
  const page = adCategoryCd ? CATEGORY[adCategoryCd] : params.page;
  const type = TYPE[destinationType];
  const url = `/${media}/${page}/${itSeq ? TYPE.T : TYPE.P}/${promotionSeq || itSeq}`;

  let query = router.query;
  query.gp_mapp_seq = gpMappSeq;
  query.ads_seq = adsSeq;
  query.pay_yn = payYn;
  query.track_cd_type = trackCdType;
  query.ads_dtl_seq = adsDtlSeq;
  if (refEventId)
    query.ref_event_id = refEventId;
  delete query.page;
  delete query.media;
  const queryString = objectToQueryString(query);
  return `${url}?${queryString}`;
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const clickEventHandler = async (item: any) => {
  const clickId = uuidv4();

  const {
    destinationUrl,
    promotionSeq,
    itSeq,
    gpMappSeq,
    adsDtlSeq,
    adsSeq,
    payYn,
    trackCd,
    deviceId,
    mediaSeq,
    adCategoryCd,
    creativeDtlSeq,
    creativeDtlType,
    trackCdType,
    clickType,
    osType,
    page,
  } = item;

  const eventName = getMoveObject(item);

  const media = CATEGORY[adCategoryCd];
  let url: string;
  const params = {
    trackCd,
    gpMappSeq,
    adsDtlSeq,
    adsSeq,
    payYn,
    platformCd: osType,
    eventType: clickType ? clickType : EVENT_TYPE.CLICK.DEFAULT,
    deviceId,
    mediaSeq,
    media,
    /* 신규추가  */
    trackCdType,
    creativeDtlSeq: itSeq || promotionSeq || creativeDtlSeq || null, // 프로모션, 상세 페이지를 띄울 경우 해당 페이지내에서 사용됨.
    creativeDtlType: itSeq ? 'I' : promotionSeq ? 'P' : creativeDtlType ? creativeDtlType : null,
    eventId: clickId,
    page,
  };
  gaTrackEvent(item);

  switch (eventName) {
    case TYPE.C:
      await Api.postCustTrxLog({
        trackCd,
        condition: params,
      });
      window.open(destinationUrl, '_blank');
      break;
    case TYPE.P:
      await Api.postCustTrxLog({
        trackCd,
        condition: params,
      });
      url = getUrl({...item, refEventId: clickId});
      await router.push(url);
      break;
    case TYPE.T:
      await Api.postCustTrxLog({
        trackCd,
        condition: params,
      });
      url = getUrl({...item, refEventId: clickId});
      await router.push(url);
      break;
    case TYPE.I:
      console.log('in app type 이건 어떻게 처리?');
      break;
    case TYPE.D:
      Api.postCustTrxLog({
        trackCd,
        condition: params,
      });
  }
};

export const getOsType = (req: any) => {
  let isIos = false;
  const userAgent = req.headers['user-agent'] ? (req.headers['user-agent'] as string) : '';
  if (userAgent) isIos = /iphone|ipad|ipod/gi.test(userAgent);
  return isIos ? 'IOS' : 'AND';
};

export const gaTrackEvent = (item: any) => {
  const {
    adsSeq,
    compNm,
    adCategoryCd,
    componentName,
    codeNm,
    eventType,
    text,
    subTitle,
    cardName,
    savingName,
    lcsBanner,
    trackCdType,
  } = item;

  if (!componentName) return;

  const media = CATEGORY[adCategoryCd];
  const name =
    media !== 'deposit' ? item[`${media === 'insurance' ? 'insu' : media}Name`] : savingName;
  const activeName = eventType === EVENT_TYPE.IMPRESSION.DEFAULT ? '노출' : '클릭';

  let category;
  let action;

  if (componentName === COMPONENT_TYPE.ROLLING) {
    category = '상단 배너';
    action = `[소재번호: ${adsSeq}][회사: ${compNm}]`;
  } else if (componentName === COMPONENT_TYPE.BOARD) {
    category = '보드 배너';
    action = `[소재번호: ${adsSeq}][회사: ${compNm}][상품명: ${subTitle}]}`;
  } else if (componentName === COMPONENT_TYPE.CATEGORY) {
    category = '상품 카테고리';
    action = `[${codeNm}]`;
  } else if (componentName === COMPONENT_TYPE.FILTER) {
    category = '정렬 순서';
    action = `[${text}]`;
  } else if (componentName === COMPONENT_TYPE.CARD_TOP) {
    category = 'TOP3 배너';
    action = `[소재번호: ${adsSeq}][회사: ${compNm}]][상품명: ${cardName}]`;
  } else if (
    componentName === COMPONENT_TYPE.LOAN ||
    componentName === COMPONENT_TYPE.CARD ||
    componentName === COMPONENT_TYPE.INSURANCE ||
    componentName === COMPONENT_TYPE.DEPOSIT
  ) {
    category = `${CATEGORY_NAME[media]}상품`;
    action = `[소재번호: ${adsSeq}][회사: ${compNm}]][상품명: ${lcsBanner ? '대출비교' : name}]`;
  } else if (componentName === COMPONENT_TYPE.TOP_SUPPORT) {
    category = '혜택 모아보기';
    action = `[소재번호: ${adsSeq}][회사: ${compNm}]][상품명: ${lcsBanner ? '대출비교' : name}]`;
  } else if (componentName === COMPONENT_TYPE.BANNER) {
    category = '콘텐츠 상품';
    action = `[소재번호: ${adsSeq}][회사: 오버테이크]`;
  }

  gtag.event({
    category: `${category} ${activeName}`,
    action,
    label: `${media} [track_cd_type : ${trackCdType}]`,
    value: null,
  });
};

const getMoveObject = (item: any) => {
  const { destinationType, promotionSeq, itSeq, destinationUrl } = item;

  if (destinationType === 'outlink') return TYPE.C;
  if (promotionSeq) return TYPE.P;
  if (itSeq) return TYPE.T;
  if (destinationUrl) return TYPE.C;
  if (destinationType) return destinationType;
};
